export enum LegalAccountState {
  Unknown,
  CredentialsNotAvailable,
  CredentialsUnauthorized,
  CredentialsCorrect,
  CredentialsAvailable
}

export class LegalAccountStateHelper {
  private static names: string[] = ["Unbekannter Status...", "Zugangsdaten nicht verfügbar", "Zugangsdaten falsch", "Zugangsdaten korrekt", "Zugangsdaten verfügbar"];

  public static GetName(value: LegalAccountState): string {
    return this.names[value];
  }
}
